import * as React from "react";


import { useTranslation } from "react-i18next";

import { ApiContext } from "../../../App";

import { default as DataGrid } from "../../../components/LocalizedDataGrid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import EditIcon from '@mui/icons-material/Edit';
import {Typography} from "@mui/material";
import {GridToolbarContainer} from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";



export default function FloorPlanEditor(props) {
	const { facility } = props;

	const { t } = useTranslation();

    const [floorPlans, setFloorPlans] = React.useState([]);

	const { floorPlanApi } = React.useContext(ApiContext)

	React.useEffect(() => {

		floorPlanApi.list(
			facility,
			(data) => {
				setFloorPlans(data);
			},
			() => {
				window.alert(t("Couldn't connect to server."));
			}
		);

	}, [facility]);

    const handleNameEdit = (url) => {

        const floorPlanName = prompt(t("New name"), "Floor plan name");

        if (floorPlanName) {

            floorPlanApi.updatePartial(
                url,
                {name: floorPlanName},
                (data) => {
                    setFloorPlans(floorPlans.map((item)=>item.url===url? data : item));
                },
                () => {
                    window.alert(t("Couldn't update floor plan."));
                }
            );

        }

    }

    const handleAddFloorPlan = (event) => {

        const file = event.target.files[0];

        const floorPlanName = prompt(t("Name"), "Floor plan name");

        if (floorPlanName) {
            floorPlanApi.createNew(
                facility,
                floorPlanName,
                file,
                (data) => {
                    setFloorPlans([...floorPlans, data]);
                },
                () => {
                    window.alert(t("Couldn't update floor plan."));
                }
            );

        }

    }


    const AddToolbar = (props) => {

        return (
            <GridToolbarContainer>
                <Button
                    color="primary"
                    startIcon={<AddIcon />}
                    component="label"
                >
                    {t("Add new")}
                    <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(event) => handleAddFloorPlan(event)}
                    />
                </Button>
            </GridToolbarContainer>
        );
    }

    const handleFileChange = (floorPlanUrl, event) => {
        const file = event.target.files[0];

        floorPlanApi.updateImage(
            floorPlanUrl,
            file,
            (data) => {
                setFloorPlans(floorPlans.map((item)=>item.url===floorPlanUrl? data : item));
            },
            () => {
                window.alert(t("Couldn't update floor plan."));
            }
        );
    };


    const columns = [
        {
            field: "name",
            headerName: t("Name"),
            flex: 1,
            minWidth: 80,
            renderCell: params => <Stack  alignItems={"center"}>
                <Typography>{params.value}</Typography>
                <Button onClick={()=>handleNameEdit(params.id)}><EditIcon/></Button>
            </Stack>
        },
        {
            field: "image",
            headerName: t("Image"),
            flex: 2,
            minWidth: 80,
            renderCell: params => <Stack>
                <img
                src={params.value}
                alt="Floor plan thumbnail"
                style={{
                    width: "250px",
                    height: "250px",
                    objectFit: "cover",
                    objectPosition: "center"
                }}
                />
                <Button component="label">
                    {t("Replace")}
                    <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(event) => handleFileChange(params.id, event)}
                    />
                </Button>

            </Stack>
        }
    ]

	return (
		<Box height={"700px"}>
            <DataGrid
                rows={floorPlans}
                columns={columns}
                rowHeight={300}
                getRowId={(row) => row.url}
                experimentalFeatures={{ newEditingApi: true }}
                components = {{
                    Toolbar: AddToolbar
                }}
            />

		</Box>
	);
}
